<template>
  <div class="bottom">
    <div class="bottom-one">
      <div class="bot-left">
        <img src="../assets/logo.png" alt="" style="visibility: hidden;" />
        <p>伴伴直播</p>
        <p>美好生活</p>
      </div>
      <div class="bot-line"></div>
      <div class="bot-p">
        <p class="bot-w">友情链接</p>
        <p
          class="bot-h"
          v-for="item in configList.friendlylist"
          :key="item.id"
          @click="gotoNewUrl(item.url)"
        >
          {{ item.title }}
        </p>
      </div>
      <div class="bot-p">
        <p class="bot-w">平台帮助</p>
        <p class="bot-h">平台公告</p>
        <p class="bot-h">帮助中心</p>
        <p class="bot-h">游戏说明</p>
      </div>
      <div class="bot-p">
        <p class="bot-w">商务合作</p>
        <img :src="configList.config?.contactCode" alt="" />
      </div>
      <div class="bot-p">
        <p class="bot-w">游戏下载</p>
        <img :src="configList.config?.downloadCode" alt="" />
      </div>
      <div class="bot-p">
        <p class="bot-w">官方微信</p>
        <img :src="configList.config?.officialCode" alt="" />
      </div>
    </div>
    <div class="bottom-two">
      <!-- · 蜀ICP备2024110027号 -->
      <p @click="gotoIndex">武汉遥景互动科技有限公司 鄂ICP备2025139487号-1</p>
    </div>
  </div>
</template>

<script>
import { configDataApi } from "../api/api.js";
export default {
  name: "Head",
  data() {
    return {
      configList: {},
    };
  },
  components: {},
  mounted() {
    this.configData();
  },
  methods: {
    async configData() {
      const res = await configDataApi();
      this.configList = res.data.data;
    },
    gotoNewUrl(url) {
      window.open(url);
    },
    gotoIndex() {
      window.location.href = "https://beian.miit.gov.cn/";
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom {
  width: 100vw;
  // position: fixed;
  // bottom: 0;
  // left: 0;
}

.bottom-one {
  width: 100%;
  padding: 30px 0;
  background: #000;
  display: flex;
  // align-items: center;
  justify-content: center;

  .bot-left {
    color: #919191;
    font-size: 18px;
    text-align: center;
    padding-right: 100px;

    img {
      width: 150px;
      padding-bottom: 20px;
    }

    p {
      padding-top: 10px;
    }
  }

  .bot-line {
    width: 1px;
    height: 176px;
    background: #5a5a5a;
  }

  .bot-p {
    padding-left: 100px;

    .bot-w {
      color: #ffffff;
      font-size: 18px;
    }

    .bot-h {
      font-size: 16px;
      color: #919191;
      padding-top: 30px;
      // cursor: pointer;
    }

    img {
      width: 115px;
      height: 115px;
      padding-top: 30px;
    }
  }
}

.bottom-two {
  width: 100%;
  color: #666666;
  font-size: 16px;
  text-align: center;
  padding: 5px 0;

  p {
    cursor: pointer;
  }
}
</style>
